import type { NodeMock, StatePreset } from "../mock-types";

export const lobbyCodeInputMock: NodeMock = {
  label: "Lobby Code Input",
  description: "Host enters the lobby code from the game",
  state: () => ({
    values: {},
    submittedBy: null,
  }),
  config: {
    timeoutSeconds: 120,
    fields: [
      { key: "lobbyCode", label: "Lobby Code", type: "text" },
      { key: "password", label: "Password", type: "password" },
    ],
    instructions: "Host: Enter the lobby code so players can join.",
    labels: {
      title: "Lobby Code",
    },
  },
};

export const lobbyCodeInputPresets: StatePreset[] = [
  {
    label: "Host - No Code",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, values: {}, submittedBy: null },
      viewAs: players[0]?.userId,
    }),
  },
  {
    label: "Code Entered",
    build: ({ players, defaultState }) => ({
      state: {
        ...defaultState,
        values: { lobbyCode: "XK7-M9R", password: "rocketleague" },
        submittedBy: players[0]?.userId,
      },
      viewAs: players[0]?.userId,
    }),
  },
  {
    label: "Non-Host",
    build: ({ players, defaultState }) => ({
      state: { ...defaultState, values: {}, submittedBy: null },
      viewAs: players[1]?.userId ?? players[0]?.userId,
    }),
  },
];
